export const environment = {
  production: true,
  appName: 'pt',
  appIconColor: '#3cd250',
  baseUrl: 'https://api.edr-software.com/report/',
  mydocmaConfig: {
    apiUrl: 'https://api.edr-software.com/mydocma/v2.0',
    clientUrl: 'https://mydocma.edr-software.com',
    appId: '9fda6b2f-fa5c-4555-ad9e-943f330ff834'
  },
  authConfig: {
    clientId: 'BayWaApp',
    scope: 'report pix offline_access iam',
    oidc: false,
    issuer: 'https://api.edr-software.com/mydocma/v2.0',
    redirectUri: 'https://pt.edr-software.com/auth/callback',
    requireHttps: false,
    responseType: 'code'
  },
};
